import { RouterProvider } from "react-router-dom";
import React from 'react';
import ReactDOM from 'react-dom/client';
import router from './router';
import './assets/css/global.css';
import './i18n';
import axios from "axios";
import { version } from "./utils/main.js";


class CacheCleaner {
  static clearOnce() {
    const savedVersion = localStorage.getItem('app_version');

    // Faqat versiya o‘zgarganda ishlasin
    if (savedVersion !== version) {

      if ('caches' in window) {
        caches.keys().then((names) => {
          names.forEach((name) => caches.delete(name));
        });
      }

      localStorage.removeItem("token");
      sessionStorage.clear();

      localStorage.setItem('app_version', version);
      window.location.reload();
    }
  }
}

CacheCleaner.clearOnce();


axios.defaults.baseURL = 'https://api.denovmart.com/';
axios.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");

  const url = config.url || "";

  // ❌ login (va boshqa auth endpointlar) uchun token qo‘shmaymiz
  const noAuthUrls = [
    "/account/login/",
    "/account/register/",
  ];

  const isNoAuth = noAuthUrls.some((u) => url.includes(u));

  if (!isNoAuth) {
    const usedToken = token;
    if (usedToken) {
      config.headers.Authorization = `token ${usedToken}`;
    }
  } else {
    // 100% kafolat uchun
    delete config.headers.Authorization;
  }

  return config;
});

window.addEventListener("error", (e) => {
  if (e.message && e.message.includes("ChunkLoadError")) {
    window.location.reload(true);
  }
});


axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const res = error?.response;
    if (!res) return Promise.reject(error);

    const { status, config } = res;
    const url = config?.url || "";
    const currentPath =
      window.location.pathname + window.location.search;

    const isMaster = url.includes("master");
    const isProfile = currentPath.includes("profile") || currentPath.includes("checkout");

    // faqat shu joylarda tekshiramiz
    if (status === 401) {
      localStorage.removeItem("token");
        if (isMaster || isProfile) {
            // tokenni tozalab login’ga yuboramiz
            localStorage.removeItem("token");
            window.location.replace("/login");
            return;
          }
        }
        
        if (status === 403) {
          window.location.href = "/uz/404/";
          return;
        }
        return Promise.reject(error);
  }
);

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);
